import { BaseNavigatorCommand } from "namirasoft-node-cli";
import { AccountLoginCommand } from "./AccountLoginCommand";
import { AccountConfigCommand } from "./AccountConfigCommand";
import { AccountLogoutCommand } from "./AccountLogoutCommand";

export class AccountCommand extends BaseNavigatorCommand
{
    constructor(argv: string[])
    {
        super(argv, {
            "config": AccountConfigCommand,
            "login": AccountLoginCommand,
            "logout": AccountLogoutCommand
        });
    }
};